import { render, staticRenderFns } from "./salesReceivingAction.vue?vue&type=template&id=884a01f0&scoped=true"
import script from "./salesReceivingAction.vue?vue&type=script&lang=js"
export * from "./salesReceivingAction.vue?vue&type=script&lang=js"
import style0 from "./salesReceivingAction.vue?vue&type=style&index=0&id=884a01f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884a01f0",
  null
  
)

export default component.exports